import { ThemeInterface } from './ThemeInterface'

export const defaultTheme: ThemeInterface = {
    mainColors: {
        primary: 'black',
        primaryHover: 'state-hover',
        secondary: 'white',
    },
}
